/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, Checkbox, Label, TextInput } from "flowbite-react";
import { type FC, useState } from "react";
import { HiEye, HiEyeOff, HiLockOpen } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const ProfileLockPage: FC = function () {
  const { t: tCommon } = useTranslation("common");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center px-6 lg:h-screen lg:gap-y-12">
      <a href="/" className="my-8 flex items-center gap-x-1 lg:my-0">
        <img
          alt="Flowbite logo"
          src="https://flowbite.com/docs/images/logo.svg"
          className="mr-3 h-10"
        />
        <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white">
          {tCommon("appName")}
        </span>
      </a>
      <Card className="w-full md:max-w-[640px] md:[&>*]:w-full md:[&>*]:p-16">
        <div className="flex items-center gap-x-4">
          <img
            alt=""
            src="/images/users/bonnie-green.png"
            className="h-9 rounded-full"
          />
          <span className="self-center whitespace-nowrap text-3xl font-semibold dark:text-white">
            Bonnie Green
          </span>
        </div>
        <p className="mb-3 text-gray-500 dark:text-gray-300">
          Better to be safe than sorry.
        </p>
        <form>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="password">{tCommon("form.password")}</Label>
            <div className="relative">
              <TextInput
                id="password"
                name="password"
                placeholder="••••••••"
                type={showPassword ? "text" : "password"}
              />
              <button
                type="button"
                className="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400"
                onClick={() => setShowPassword((prev) => !prev)}
                tabIndex={-1}
              >
                {showPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <div className="mb-6 flex items-center gap-x-3">
            <Checkbox id="acceptTerms" name="acceptTerms" />
            <Label htmlFor="acceptTerms">
              {tCommon("form.accept")}&nbsp;
              <a href="#" className="text-primary-700 dark:text-primary-300">
                {tCommon("form.termsAndConditions")}
              </a>
            </Label>
          </div>
          <div>
            <Button type="submit" className="w-full lg:w-auto">
              <HiLockOpen className="mr-2 text-xl" />
              {tCommon("unlock")}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default ProfileLockPage;
